var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7092_6062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7092_6062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.5V15.5H5.5V18.1L8.6 15L10 16.4L6.9 19.5H9.5V21.5H3.5ZM15.5 21.5V19.5H18.1L15 16.4L16.4 15L19.5 18.1V15.5H21.5V21.5H15.5ZM8.6 10L5.5 6.9V9.5H3.5V3.5H9.5V5.5H6.9L10 8.6L8.6 10ZM16.4 10L15 8.6L18.1 5.5H15.5V3.5H21.5V9.5H19.5V6.9L16.4 10ZM12.5 14.5C11.95 14.5 11.4792 14.3042 11.0875 13.9125C10.6958 13.5208 10.5 13.05 10.5 12.5C10.5 11.95 10.6958 11.4792 11.0875 11.0875C11.4792 10.6958 11.95 10.5 12.5 10.5C13.05 10.5 13.5208 10.6958 13.9125 11.0875C14.3042 11.4792 14.5 11.95 14.5 12.5C14.5 13.05 14.3042 13.5208 13.9125 13.9125C13.5208 14.3042 13.05 14.5 12.5 14.5Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsOutput);
export default __webpack_public_path__ + "static/media/arrowsOutput.ca2f569bc0d89cd048ba90b654d8caa2.svg";
export { ForwardRef as ReactComponent };